// export const graphqlUri = "http://3.39.203.58:4000";

export const graphqlUri = "https://api.hbpay.kr";
